import React from "react";

const Error: React.FC = () => {
  return (
    <div>
      <h1>Error Request</h1>
    </div>
  );
};

export default Error;
